import React from "react";

import "./Toolbar.css";
import Logo from "../../../Logo/Logo";
import NavigationItems from "../NavigationItems/NavigationItems";
import DrawerToggle from "../SideDrawer/DrawerToggle/DrawerToggle";

const toolbar = props => (
  <header className="ToolbarArchitecture">
    <DrawerToggle clicked={props.drawerToggleClicked} />
    <div className="d-flex">
      <a href="/">
        <Logo />
      </a>
      <p className="text-light m-2 align-self-center">AKCENTBUD Architektura</p>
    </div>
    <nav className="DesktopOnly">
      <NavigationItems />
    </nav>
  </header>
);

export default toolbar;



// WEBPACK FOOTER //
// ./src/components/Architecture/Navigation/Toolbar/Toolbar.js